import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Accordion, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../config/abilityContext';
import { SimpleCenteredModal } from '../../components';
import { createMassiveUnjustifiedAbsenceRequest } from '../../requests/unjustifiedAbsences';
import { sendAlert } from '../../actions/utils';
import UnjustifiedAbsenceForm from './UnjustifiedAbsenceForm';
import UnjustifiedAbsenceFilter from './UnjustifiedAbsenceFilter';
import UnjustifiedAbsenceDataTable from './UnjustifiedAbsenceDataTable';
import columns from './columns';
import './style.scss';

const basicAbsence = () => ({ date: '', reason: '', employeeIds: [], file: null });

const UnjustifiedAbsenceIndex = () => {
  const ability = useAbility(AbilityContext);
  const dispatch = useDispatch();
  const [moreData, setMoreData] = useState(false);
  const [absence] = useState(basicAbsence());
  const [modalShow, setModalShow] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState('0');
  const [filters, setFilters] = useState({});
  const [hasSearched, setHasSearched] = useState(false);

  const handleFilterAdvance = values => {
    setFilters(snakeCaseKeys(values));
    setMoreData(prev => !prev);
    setHasSearched(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleCreateRequest = unjustifiedAbsence => {
    const { file } = unjustifiedAbsence.unjustifiedAbsence;
    const myParams = snakeCaseKeys(unjustifiedAbsence);
    myParams.unjustified_absence.file = file;

    createMassiveUnjustifiedAbsenceRequest({
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => {
        setMoreData(!moreData);
        dispatch(
          sendAlert({
            kind: 'success',
            message: 'Creación de Ausencias Realizada de Manera Correcta'
          })
        );
        handleModalClose();
      }
    });
    return true;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Row className="my-4">
        <Col>
          <h2 className="text-uppercase mt-3">Justificación Ausentismo</h2>
        </Col>
        {ability.can('create', 'UnjustifiedAbsence') && (
          <Col md={2} className="d-flex justify-content-end">
            <Button variant="primary" className="mt-2 btn-new-absence" onClick={() => setModalShow(true)}>
              Nuevo
            </Button>
          </Col>
        )}
      </Row>

      <Accordion activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-3">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>FILTROS DE BÚSQUEDA</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              <UnjustifiedAbsenceFilter formRequest={handleFilterAdvance} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <div className="data-table-yellow">
        {hasSearched && (
          <UnjustifiedAbsenceDataTable
            customParams={filters}
            columns={columns}
            moreData={moreData}
            setMoreData={setMoreData}
          />
        )}
      </div>

      <SimpleCenteredModal
        title="Nueva Justificación Ausentismo"
        show={modalShow}
        size="lg"
        body={
          <UnjustifiedAbsenceForm
            action="new"
            formRequest={handleCreateRequest}
            hideModal={() => setModalShow(false)}
            unjustifiedAbsence={absence}
          />
        }
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default UnjustifiedAbsenceIndex;
